import { useTranslation } from 'react-i18next';
import { FC } from 'react';

type ConfirmPopupProps = {
  title?: string;
  message?: string;
  handleConfirm: VoidFunction;
  handleCancel?: VoidFunction;
  handleClose?: VoidFunction;
  confirmOnly?: boolean;
}

export const ConfirmPopUp: FC<ConfirmPopupProps> = ({
  title = '',
  message = '',
  handleConfirm,
  handleCancel,
  handleClose,
  confirmOnly = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="bg-walletConnectBlur font-skolar fixed inset-[-200px] z-50 flex items-center justify-center"
      onClick={() => handleClose && handleClose()}
    >
      <div
        className="bg-popupBackground xs:max-w-screen-xxxs flex h-auto min-h-[150px] min-w-[300px] max-w-[375px] flex-col items-center justify-center rounded-lg border border-b-4 border-black px-8 py-4 text-center md:w-[500px] md:max-w-none"
        onClick={(e) => e.stopPropagation()}
      >
        <h1 className="mb-4 text-sm font-medium md:text-base">
          {title}
        </h1>
        <h3 className="mb-4 font-poppins text-sm font-normal md:text-base">
          {message}
        </h3>
        <div className="flex flex-col items-center gap-4 md:flex-row">
          <button
            type="button"
            className="text-shadow-custom green-button flex h-[50px] w-[150px] text-xl font-bold"
            onClick={handleConfirm}
          >
            {t('confirmationPopup.accept')}
          </button>
          {!confirmOnly && (
            <button
              type="button"
              className="text-shadow-custom red-button relative flex h-[50px] w-[150px] text-xl font-bold"
              onClick={() => handleCancel && handleCancel()}
            >
              {t('confirmationPopup.cancel')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
